import { cn } from '@forest/shared'
import { createUniqueId } from 'solid-js'

// The ×2 tag on a Time Crystal pack card while its First-purchase bonus is
// active (GLOSSARY.md "First-purchase bonus (首購翻倍)") — campaign art, not
// the bonus amount. 42px unless the caller's `class` sizes it. The glyphs'
// drop-shadow filter ids are unique per instance: every bonus card renders
// one, and a duplicated id would resolve to the first card's filter.
export function FirstPurchaseBonusTagIcon(props: {
  class?: string
  testId?: string
}) {
  const id = createUniqueId()
  const timesFilter = `first-purchase-bonus-times-${id}`
  const twoFilter = `first-purchase-bonus-two-${id}`
  return (
    <svg
      aria-hidden="true"
      data-testid={props.testId}
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={cn('size-[42px]', props.class)}
    >
      <path
        d="M28.761 39.7976C27.801 39.9676 26.841 39.9176 25.911 39.6476L24.271 39.1776L22.891 40.1876C22.101 40.7576 21.221 41.1376 20.261 41.3076C17.941 41.7176 15.601 40.8176 14.161 38.9576L13.111 37.6076H11.401C7.96096 37.6076 5.18096 34.9176 5.06096 31.4776L5.00096 29.7676L3.62096 28.7676C0.840958 26.7476 0.170958 22.9276 2.10096 20.0776L3.06096 18.6576L2.53096 17.0276C1.47096 13.7576 3.17096 10.2776 6.40096 9.10763L8.01096 8.52763L8.54096 6.89763C9.27096 4.65763 11.161 3.01763 13.481 2.60763C14.441 2.43763 15.401 2.48763 16.331 2.75763L17.971 3.22763L19.351 2.21763C20.141 1.64763 21.021 1.26763 21.981 1.09763C24.301 0.687626 26.641 1.58763 28.081 3.44763L29.131 4.79763H30.841C34.281 4.79763 37.061 7.48763 37.181 10.9276L37.241 12.6376L38.621 13.6376C41.401 15.6576 42.071 19.4776 40.141 22.3276L39.181 23.7476L39.711 25.3776C40.771 28.6476 39.071 32.1276 35.841 33.2976L34.231 33.8776L33.701 35.5076C32.971 37.7476 31.081 39.3876 28.761 39.7976Z"
        fill="white"
      />
      <path
        d="M18.591 6.16762L20.961 4.44762C22.531 3.30762 24.711 3.61762 25.901 5.14762L27.701 7.45762C27.751 7.51762 27.821 7.55762 27.901 7.55762H30.831C32.771 7.55762 34.351 9.09762 34.421 11.0276L34.521 13.9576C34.521 14.0376 34.561 14.1076 34.621 14.1576L36.991 15.8776C38.561 17.0176 38.941 19.1876 37.851 20.7976L36.211 23.2276C36.171 23.2876 36.151 23.3776 36.181 23.4476L37.091 26.2376C37.691 28.0776 36.721 30.0676 34.901 30.7176L32.141 31.7176C32.071 31.7476 32.011 31.8076 31.981 31.8776L31.071 34.6676C30.471 36.5076 28.521 37.5476 26.661 37.0076L23.841 36.1976C23.761 36.1776 23.681 36.1976 23.621 36.2376L21.251 37.9576C19.681 39.0976 17.501 38.7876 16.311 37.2576L14.511 34.9476C14.461 34.8876 14.391 34.8476 14.311 34.8476H11.381C9.441 34.8476 7.861 33.3076 7.791 31.3776L7.691 28.4476C7.691 28.3676 7.651 28.2976 7.591 28.2476L5.221 26.5276C3.651 25.3876 3.271 23.2176 4.361 21.6076L6.001 19.1776C6.041 19.1176 6.061 19.0276 6.031 18.9576L5.121 16.1676C4.521 14.3276 5.491 12.3376 7.311 11.6876L10.071 10.6876C10.141 10.6576 10.201 10.5976 10.231 10.5276L11.141 7.73762C11.741 5.89762 13.691 4.85762 15.551 5.39762L18.371 6.20762C18.451 6.22762 18.531 6.20762 18.591 6.16762Z"
        fill="#FF9796"
      />
      <g filter={`url(#${timesFilter})`}>
        <path
          d="M12.2009 24.8383C11.6809 24.2983 11.7009 23.6082 12.2709 23.0582L14.0809 21.2983L12.4509 19.6183C11.8909 19.0383 11.8709 18.3683 12.4009 17.8583C12.9309 17.3483 13.6109 17.3783 14.1709 17.9583L15.8009 19.6382L17.5509 17.9483C18.1309 17.3883 18.8209 17.3882 19.3409 17.9182C19.8609 18.4482 19.8509 19.1482 19.2709 19.7182L17.5209 21.4082L19.1809 23.1183C19.7409 23.6983 19.7509 24.3782 19.2309 24.8882C18.7109 25.3982 18.0309 25.3683 17.4709 24.7883L15.8109 23.0782L14.0009 24.8383C13.4209 25.3983 12.7309 25.3883 12.2109 24.8483L12.2009 24.8383Z"
          fill="white"
        />
      </g>
      <g filter={`url(#${twoFilter})`}>
        <path
          d="M22.811 23.2379L25.851 20.1079C26.791 19.1479 27.191 18.5179 27.191 17.8479C27.191 16.9879 26.571 16.4079 25.641 16.4079C24.891 16.4079 24.351 16.7879 23.961 17.5679C23.571 18.1679 23.241 18.3979 22.731 18.3979C22.031 18.3979 21.551 17.9279 21.551 17.2579C21.551 15.6179 23.401 14.0879 25.801 14.0879C28.201 14.0879 29.991 15.5679 29.991 17.5779C29.991 18.8179 29.391 19.9079 27.921 21.3479L25.411 23.8779V23.9979H29.071C29.891 23.9979 30.401 24.4379 30.401 25.1579C30.401 25.8779 29.901 26.2979 29.071 26.2979H23.051C22.201 26.2979 21.631 25.8179 21.631 25.0779C21.631 24.5479 21.921 24.0979 22.801 23.2279L22.811 23.2379Z"
          fill="white"
        />
      </g>
      <defs>
        <GlyphGlowFilter
          id={timesFilter}
          x="5.82642"
          y="11.498"
          width="19.8926"
          height="19.7578"
        />
        <GlyphGlowFilter
          id={twoFilter}
          x="15.551"
          y="8.08789"
          width="20.8501"
          height="24.21"
        />
      </defs>
    </svg>
  )
}

// The white 3px glow behind each glyph, as exported from the design.
function GlyphGlowFilter(props: {
  height: string
  id: string
  width: string
  x: string
  y: string
}) {
  return (
    <filter
      id={props.id}
      x={props.x}
      y={props.y}
      width={props.width}
      height={props.height}
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="3" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow"
        result="shape"
      />
    </filter>
  )
}
